;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import NotificationItem from '@/components/notifications/notification-item';
import type { NotificationsList as NotificationsListType } from '@/types/notifications';

export default function NotificationsList({
  notificationsList,
}: {
  notificationsList: NotificationsListType;
}) {
  return (
    <div className="flex max-h-[calc(60vh-113px)] min-h-[calc(60vh-113px)] flex-col gap-2 overflow-y-auto lg:max-h-[40vh] lg:min-h-1">
      {notificationsList.length > 0 ? (
        notificationsList.map((item) => (
          <NotificationItem key={`user_${item.notification_user_id}`} item={item} />
        ))
      ) : (
        <div className="flex items-center justify-center py-8">
          <p className="text-grey-600 text-sm leading-8">
            {"You don't have any notifications yet"}
          </p>
        </div>
      )}
    </div>
  );
}
